export const getLabelColor = (color: number): string => {
  switch (color) {
    case 1:
      return 'bg-label1';
    case 2:
      return 'bg-label2';
    case 3:
      return 'bg-label3';
    case 4:
      return 'bg-label4';
    case 5:
      return 'bg-label5';
    case 6:
      return 'bg-label6';
    case 7:
      return 'bg-label7';
    case 8:
      return 'bg-label8';
    default:
      return '';
  }
};
